import React from 'react';
import { CheckCircle, Users, Award, Activity } from 'lucide-react';
import { stats } from '../data/mock';

const iconMap = {
  'check-circle': CheckCircle,
  'users': Users,
  'award': Award,
  'activity': Activity
};

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Why Choose Tech360?
            </h2>
            <p className="text-xl text-gray-600 mb-4 leading-relaxed">
              Led by <span className="font-bold text-emerald-600">Er. Prashant Kumar</span>, Owner & CEO, we bring years of expertise and proven methodologies to deliver IT infrastructure solutions that drive business growth and operational excellence.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our commitment is to provide cutting-edge technology solutions tailored to your business needs with unmatched support and reliability.
            </p>

            {/* CEO Photo Section */}
            <div className="bg-gradient-to-r from-emerald-50 to-cyan-50 rounded-2xl p-6 mb-8 border-2 border-emerald-100">
              <div className="flex items-center gap-6">
                <div className="relative">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-emerald-500 shadow-lg">
                    <img 
                      src="https://customer-assets.emergentagent.com/job_corporate-connect-18/artifacts/att4qvtn_1000030012.jpg"
                      alt="Er. Prashant Kumar - CEO"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center border-2 border-white">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Er. Prashant Kumar</h3>
                  <p className="text-emerald-600 font-semibold text-lg">Owner & CEO</p>
                  <p className="text-gray-600 mt-1 italic">"Leading innovation in technology solutions"</p>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                    <CheckCircle className="w-6 h-6 text-emerald-600" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Certified Professionals</h3>
                  <p className="text-gray-600">Our team holds industry-leading certifications and follows best practices for every deployment.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center">
                    <Award className="w-6 h-6 text-cyan-600" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Quality Assurance</h3>
                  <p className="text-gray-600">Rigorous testing and quality checks ensure your infrastructure performs flawlessly.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                    <Activity className="w-6 h-6 text-emerald-600" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">24/7 Support</h3>
                  <p className="text-gray-600">Round-the-clock monitoring and support to keep your business running without interruption.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Stats Grid */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat) => {
              const Icon = iconMap[stat.icon];
              return (
                <div 
                  key={stat.label}
                  className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 border-2 border-gray-200 hover:border-emerald-500 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                >
                  <Icon className="w-10 h-10 text-emerald-600 mb-4" />
                  <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
